import React from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { PageLoader } from 'app/views/components/layout/page-loader'
import { MantineProvider } from '@mantine/core'
import { Notifications } from '@mantine/notifications'
import { ModalsProvider } from '@mantine/modals'
import { useDocumentRefreshFailures } from 'app/hooks/useDocumentRefreshFailures'
import { useAccessTokenCookie } from 'app/hooks/useAccessTokenCookie'
import { RightPedalRoutes } from './routes'

export const MainSwitch: React.FC = () => {
  const { isLoading } = useAuth0()
  // the API client's token cookie; no page reads before it is in place
  const tokenReady = useAccessTokenCookie()

  // Background document refreshes fail after their request has already
  // answered, so the session listens for them here rather than on any one page.
  useDocumentRefreshFailures()

  if (isLoading || !tokenReady) {
    return (
      <div className="page-layout">
        <PageLoader />
      </div>
    )
  }
  return (
    <MantineProvider
      theme={{
        fontFamily: 'Plus Jakarta Sans',
        colors: {
          'primary-blue': [
            '#ECEEF9',
            '#C9CFEE',
            '#A6B0E2',
            '#8491D7',
            '#6173CC',
            '#3F54C1',
            '#32439A',
            '#263273',
            '#19214D',
          ],
          'prime-purple': [
            '#3F036D',
            '#3F036D',
            '#3F036D',
            '#3F036D',
            '#3F036D',
            '#3F036D',
            '#3F036D',
            '#3F036D',
            '#3F036D'
          ]
        },

      }}
    >
      <ModalsProvider>
        <Notifications />
        <RightPedalRoutes />
      </ModalsProvider>
    </MantineProvider >
  )
}

export default MainSwitch
